<template>
  <div class="addressList">
    <myHeader :headerData="headerData[platform-1]||headerData"></myHeader>
    <div class="addressRow" v-for=" (item,index) in addressData" :key="index">
      <p>
        <span>{{item.receiverName||'暂无收货人'}}</span>
        <span class="phoneNumber">{{item.receiverTel||'暂无收货人电话'}}</span>
      </p>
      <p class="addressContent">{{(item.provinceName+item.cityName+item.countyName+item.roadDetail)||'暂无收货地址'}}</p>
      <p class="operationRow">
        <label class="mint-radiolist-label" @click.prevent="SetDefault(item)">
          <span class="mint-radio">
            <input type="radio" class="mint-radio-input" name="isDefault" :checked="item.isDefault">
            <span class="mint-radio-core"></span>
          </span>
          <span class="mint-radio-label">默认地址</span>
        </label>
      <div class="operationBtn" @click="deleteAddress(item.addressId)">
        <i class="icons icon-delete"></i>
        <span>删除</span>
      </div>
      <div class="operationBtn" @click="editAndNewAddress(item,1)">
        <i class="icons icon-edit"></i>
        <span>编辑</span>
      </div>
      </p>
    </div>
    <div class="noAddress" v-if="!addressData.length">
      <p>
        <i class="icons icon-noAddress"></i>
      </p>
      <span>暂无收货地址</span>
    </div>
    <div class="newAddress" @click="editAndNewAddress">
      <mt-button type="primary" size="large">
        <i class="icons icon-new"></i>
        <span class="newAddressText">新建地址</span>
      </mt-button>
    </div>
  </div>
</template>

<script>
  import myHeader from '../components/header.vue';
  import {MessageBox} from 'mint-ui';
  export default {
    name: 'addressList',
    components: {
      myHeader
    },
    created: function () {
        var query=this.$route.query
        if(query&&query.platform){
          this.platform=query.platform;
        }
        //当从chooseAddress跳转 外卖和礼品header都是收货地址管理
        if(query.headerData){
          this.headerData=query.headerData;
        }

        this.getAddress();
    },
    methods: {
      getAddress(){
        var _this=this;
        this.$http.get(this.$api.QueryMyAddresses, {platform:this.platform}, function (res) {
          _this.addressData = res.content
        })
      },
      SetDefault(item){
        if(item.isDefault)return;
        var _this = this;
        this.$http.post(this.$api.SetDefaultAddress, {'addressId': item.addressId, 'isDefault': true}, function (res) {
          if (res.success) {
            _this.$toast('设置成功!');
            _this.getAddress();
          } else {
            _this.$toast(res.msg);
          }
        })
      },
      deleteAddress(id){
        MessageBox({
          title: this.deleteTip[this.platform-1].title,
          message: this.deleteTip[this.platform-1].message,
          showCancelButton: true
        }).then(action => {
          if (action == 'confirm') {
            var _this = this;
            this.$http.post(this.$api.DeleteAddress, {addressId: id}, function (res) {
              if (res.success) {
                _this.$toast('删除成功!');
                _this.getAddress();
              } else {
                _this.$toast(res.msg);
              }
            })
          }
        });
      },
      editAndNewAddress(item,type){
        item = item || '';
       //if (!type && this.addressData.length >= 5) {
         //this.$toast('最多只能添加5个收货地址!');
         //return;
       //}
        var name='';
        if(this.platform==1){
          name='giftEditAndSave'
        }else if(this.platform==2){
          name="takeOutEditAndSave"
        }
        this.$router.push({name: name, query: {addressItem: item}})
      },
    },
    data () {
      return {
        //platform含义(0:我们Our,1:礼品Gift,2:外卖Takeout)
        headerData:[         
          {
            name: '礼品收货地址',
            isOut: false,
            save: false            
          },
          {
            name: '预约外卖收货地址',
            isOut: false,
            save: false            
          }          
        ],
        deleteTip:[
          {
            title:'删除礼品收货地址',
            message:'是否删除礼品收货地址?'
          },
          {
            title:'删除预约外卖收货地址',
            message:'是否删除预约外卖收货地址?'
          }          
        ],
        addressData: [],
        platform:''
      }
    }
  }
</script>
<style scoped>
  .addressList {
    padding-bottom: 60px;
  }

  .operationRow {
    margin-top: 10px;
  }

  .operationBtn {
    float: right;
    color: #999;
    margin-left: 10px;
    margin-top: 5px;
  }

  .operationBtn span, .operationBtn i {
    float: left;
  }

  .operationBtn span {
    margin-top: -4px;
    margin-left: 2px;
  }

  .newAddress {
    position: fixed;
    bottom: 0;
    left: 0;
    background: #fff;
    width: 94%;
    padding: 10px 3%;
  }

  .newAddressText {
    font-size: 16px;
    display: inline-block;
  }

  .noAddress {
    margin-top: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/addressList.vue